import { combineReducers } from 'redux';

import type { Action } from 'modules/global/generic.types';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import type { Nullable } from 'modules/global/typing/common/common';
import { FETCH_GUIDELINE, SELECT_GUIDELINE } from 'modules/guidelines/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const selectedId = createReducer<Nullable<string>>(null, {
  [SELECT_GUIDELINE]: (_, { payload }: Action<string>) => payload as string,
});

export default combineReducers({
  selectedId,
  loading: loading(FETCH_GUIDELINE),
  error: error(FETCH_GUIDELINE),
});
